import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'ARCHIVE',
  title: 'Wie kann ich mein Archiv einsehen?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Jedes hochgeladene Dokument bleibt zugänglich, auch nach seinem Ablauf.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf der Registerkarte "Dokumente" auf "Meine Archive einsehen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ARCHIVE/DE_ARCHIVE.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Sie können dann auf Ihre Archive zugreifen und sie herunterladen.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Diese Archive werden 15 Jahre lang gespeichert und sind auch für Ihre Kunden zugänglich.'
  }]
};
